var _circle;
import { createTablerIcon } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createTablerIcon({
  Content() {
    return _circle || (_circle = /*#__PURE__*/_jsx("circle", {
      cx: 12,
      cy: 12,
      r: 5,
      fill: "currentColor"
    }));
  },
  name: 'circle filled'
});